export function file() {

}

//格式化文件大小
file.prototype.formatSize = function (size) {
    if (!size) return 0;
    var num = 1024.0; //byte
    if (size < num) return size + " B";
    if (size < Math.pow(num, 2)) return (size / num).toFixed(2) + " KB"; //kb
    if (size < Math.pow(num, 3))
        return (size / Math.pow(num, 2)).toFixed(2) + " MB"; //M
    if (size < Math.pow(num, 4))
        return (size / Math.pow(num, 3)).toFixed(2) + " GB"; //G
    return (size / Math.pow(num, 4)).toFixed(2) + " TB"; //T
}

//获取文件信息
file.prototype.getFInfo = function (path) {
    let finfo = {}
    let pos = path.lastIndexOf("/");
    finfo.dir = path.substring(0, pos);
    let names = path.substring(pos + 1).split(".");
    finfo.name = names[0];
    finfo.ext = names.length > 1 ? names[1] : "";
    return finfo
}